import { render, staticRenderFns } from "./ProposalSelectionDropdown.vue?vue&type=template&id=eef5efa6"
import script from "./ProposalSelectionDropdown.vue?vue&type=script&lang=js"
export * from "./ProposalSelectionDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports